var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6875 5.25C1.6875 4.93934 1.93934 4.6875 2.25 4.6875H15.75C16.0607 4.6875 16.3125 4.93934 16.3125 5.25C16.3125 5.56066 16.0607 5.8125 15.75 5.8125H2.25C1.93934 5.8125 1.6875 5.56066 1.6875 5.25Z",
    fill: "#1C1B1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.9375 9C3.9375 8.68934 4.18934 8.4375 4.5 8.4375H13.5C13.8107 8.4375 14.0625 8.68934 14.0625 9C14.0625 9.31066 13.8107 9.5625 13.5 9.5625H4.5C4.18934 9.5625 3.9375 9.31066 3.9375 9Z",
    fill: "#1C1B1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.9375 12.75C6.9375 12.4393 7.18934 12.1875 7.5 12.1875H10.5C10.8107 12.1875 11.0625 12.4393 11.0625 12.75C11.0625 13.0607 10.8107 13.3125 10.5 13.3125H7.5C7.18934 13.3125 6.9375 13.0607 6.9375 12.75Z",
    fill: "#1C1B1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortBlack);
export default __webpack_public_path__ + "static/media/sort-black.93bc7b09394e18ddded05aaa451f6a17.svg";
export { ForwardRef as ReactComponent };